import { IDataItem } from 'aw-data-card'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import './CardSchedules.scss'
import ModalSchedules, { SchedulesFields } from '../ModalSchedules/ModalSchedules.component';
export interface Schedule {
    field: string,
    show: boolean,
    order: number,
    active: boolean,
    startTime: string,
    endTime: string,
}
export const weeklyScheduleData: Schedule[] = [
  {
    field: 'Monday',
    show: true,
    order: 1,
    active: true,
    startTime: '08:00',
    endTime: '17:00',
  },
  {
    field: 'Tuesday',
    show: true,
    order: 2,
    active: true,
    startTime: '08:00',
    endTime: '17:00',
  },
  {
    field: 'Wednesday',
    show: true,
    order: 3,
    active: true,
    startTime: '08:00',
    endTime: '17:00',
  },
  {
    field: 'Thursday',
    show: true,
    order: 4,
    active: true,
    startTime: '08:00',
    endTime: '17:00',
  },
  {
    field: 'Friday',
    show: true,
    order: 5,
    active: true,
    startTime: '08:00',
    endTime: '17:00',
  },
  {
    field: 'Saturday',
    show: true,
    order: 6,
    active: false,
    startTime: '08:00',
    endTime: '12:00',
  },
  {
    field: 'Sunday',
    show: true,
    order: 7,
    active: false,
    startTime: '00:00',
    endTime: '00:00',
  },
];

const CardSchedules = (
    props: {
        idmachine: string,
        token: string,
        refresh?: boolean,
    }
) => {
    useEffect(() => {
        setSchedules(weeklyScheduleData)
        setCardSchedules(weeklyScheduleData)
        setSchedulesOld(weeklyScheduleData)
    }, [])
    const { t } = useTranslation();
    const [cardSchedules, setCardSchedules] = useState<Schedule[]>([])
    const [schedules, setSchedules] = useState<Schedule[]>([])
    const [schedulesOld, setSchedulesOld] = useState<Schedule[]>([])
    const [showModal, setShowModal] = useState(false)

    const onChangeParams = (field: string, subField: SchedulesFields, value: number) => {
        setSchedules((prevSchelules) => {            
            return prevSchelules.map((schedule) =>
                schedule.field === field
                    ? { ...schedule, [subField] : value }
                    : schedule
            );
        });
    };

    const onClickCancel = () => {
        setSchedules(schedulesOld)
        setShowModal(false)
    }

    const onClickSave = () => {
        if (schedules) {
            setCardSchedules(schedules)
            setShowModal(false)
        }
    }


    return (
        <>
            <ModalSchedules
                onHide={onClickCancel}
                onSave={onClickSave}
                showModal={showModal}
                params={schedules}
                onChangeParams={onChangeParams}
            />
            <div className='pt-2 text-center rounded-1 cardSchedulesContainer'>
                <div className='d-flex justify-content-between align-items-center'>
                    <p className='mt-1 h4 text-center flex-grow-1'>{t("Schedules")}</p>
                </div>

                <button type='button' onClick={() => setShowModal(true)} className={`btn btn-Custom btn-IDGreen button-container`}>
                    <i className={"bi bi-pencil"}></i>
                </button>

                <div className='px-1 py-2'>
                    <div className='table-responsive'>
                        <table className='table dataContainer mt-1'>
                            <tbody>
                                {cardSchedules.map((item) => (
                                    <tr key={item.field}>
                                        <td className='label-col'>{t(item.field)}</td>
                                        <td className='value-col-1'>{item.active ? "On" : "Off"}</td>
                                        <td className='value-col-2'>{item.startTime}</td>
                                        <td className='value-col-2'>{item.endTime}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CardSchedules